import { getCurrentLocale } from '../i18n'

export const getApiLanguageHeader = (): string => {
  // Map i18n locale to API language format
  const locale = getCurrentLocale()
  switch (locale) {
    case 'no':
      return 'nb-NO'
    case 'en':
      return 'en-GB'
    default:
      return 'nb-NO'
  }
}

export const getDefaultHeaders = async (token?: string): Promise<HeadersInit> => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Accept-Language': getApiLanguageHeader()
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}
